import { render, staticRenderFns } from "./ModalComplementos.vue?vue&type=template&id=7e6cba82&scoped=true&style=border-radius%3A%2010px"
import script from "./ModalComplementos.vue?vue&type=script&lang=js"
export * from "./ModalComplementos.vue?vue&type=script&lang=js"
import style0 from "./ModalComplementos.vue?vue&type=style&index=0&id=7e6cba82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6cba82",
  null
  
)

export default component.exports